import { Link } from 'gatsby'
import React from 'react'
import { Image } from 'src/components/ui/Image'

interface CartaoPresenteMainBannerSectionDataProps {
  title: string
  link: string
  imageDesktop: string
  imageMobile: string
}

const CartaoPresenteMainBannerSectionData: React.FC<
  CartaoPresenteMainBannerSectionDataProps
> = ({ title, imageDesktop, imageMobile, link }) => {
  return (
    <section className="w-full max-w-[1440px] mx-auto flex flex-col-reverse md:flex-row items-center justify-center">
      <Link
        to={link || '/cartao-presente/p'}
        className="w-full flex justify-center items-center cursor-pointer"
      >
        <Image
          src={imageDesktop}
          alt={title}
          className="hidden sm:block w-full h-full"
        />
        <Image
          src={imageMobile}
          alt={title}
          className="block sm:hidden w-full h-full"
        />
      </Link>
    </section>
  )
}

export default CartaoPresenteMainBannerSectionData
